import { Pagination as DSPagination, desktopFirstMediaQuery } from '@inflearn/ds-react';
import type { PaginationProps } from '@inflearn/ds-react';

type Props = Pick<PaginationProps, 'value' | 'defaultValue' | 'total' | 'onChange'>;

export default function Pagination(props: Props) {
  return (
    <>
      <DSPagination
        css={{
          display: 'none',
          [desktopFirstMediaQuery.mobile]: { display: 'flex' },
        }}
        my={32}
        position="center"
        radius="md"
        size="md"
        withControls={false}
        withEdges={false}
        {...props}
      />
      <DSPagination
        css={{
          [desktopFirstMediaQuery.mobile]: { display: 'none' },
        }}
        my={32}
        position="center"
        radius="md"
        size="lg"
        withControls
        withEdges={false}
        {...props}
      />
    </>
  );
}
